var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../service/api.service';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
var KtsConstructionMaterialService = /** @class */ (function (_super) {
    __extends(KtsConstructionMaterialService, _super);
    function KtsConstructionMaterialService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        return _this;
    }
    KtsConstructionMaterialService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsConstructionMaterialService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return KtsConstructionMaterialService;
}(ContentBaseService));
export { KtsConstructionMaterialService };
// material_m
var Material = /** @class */ (function () {
    function Material() {
    }
    return Material;
}());
export { Material };
// material_u
var ConstructionMaterial = /** @class */ (function () {
    function ConstructionMaterial() {
        this.$type = "post" /* Post */;
    }
    return ConstructionMaterial;
}());
export { ConstructionMaterial };
var MaterialData = /** @class */ (function (_super) {
    __extends(MaterialData, _super);
    function MaterialData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MaterialData;
}(Material));
export { MaterialData };
var GeneralMaterialData = /** @class */ (function () {
    function GeneralMaterialData() {
        this.$type = "post" /* Post */;
    }
    return GeneralMaterialData;
}());
export { GeneralMaterialData };
var TaskTemplate = /** @class */ (function () {
    function TaskTemplate(msg, readonly) {
        this.date = [];
        this.deliveryDestination = [];
        this.materialNormal = [];
        this.materialSpecial = [];
        this.date = [{
                controlType: 'date',
                label: msg['au.COMPONENTS.label.task_plan_date'],
                key: 'plan_date',
                readonly: true
            }, {
                controlType: 'date',
                label: msg['au.COMPONENTS.label.task_act_date'],
                key: 'act_date',
                readonly: readonly
            }];
        this.deliveryDestination = [{
                controlType: 'date',
                label: msg['au.COMPONENTS.label.task_desire_date'],
                key: 'desire_date',
                readonly: readonly
            }, {
                controlType: 'date',
                label: msg['au.COMPONENTS.label.task_order_date'],
                key: 'order_date',
                readonly: readonly
            }, {
                controlType: 'date',
                label: msg['au.COMPONENTS.label.task_delivery_date'],
                key: 'delivery_date',
                readonly: readonly
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_delivery_name'],
                key: 'name',
                readonly: readonly
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_delivery_zipcode'],
                key: 'zipcode',
                readonly: readonly
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_delivery_address'],
                key: 'address',
                readonly: readonly,
                params: { formClass: { width: '50per' } }
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_delivery_tel'],
                key: 'tel',
                readonly: readonly
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_delivery_charge'],
                key: 'charge',
                readonly: readonly
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_delivery_arrival_note'],
                key: 'arrival_note',
                readonly: readonly,
                params: { formClass: { width: '50per' } }
            }];
        this.materialNormal = [{
                key: 'material',
                readonly: readonly,
                items: [{
                        label: msg['au.COMPONENT.KtsConstructionMaterialComponent.label.id'],
                        items: [{
                                controlType: 'label',
                                key: 'id'
                            }]
                    }, {
                        label: msg['au.COMPONENT.KtsConstructionMaterialComponent.label.type'],
                        items: [{
                                hidden: true,
                                key: 'type'
                            }, {
                                controlType: 'label',
                                label: ''
                            }]
                    }, {
                        label: msg['au.COMPONENT.KtsConstructionMaterialComponent.label.code'],
                        items: [{
                                controlType: 'label',
                                key: 'code'
                            }]
                    }, {
                        label: msg['au.COMPONENT.KtsConstructionMaterialComponent.label.name'],
                        items: [{
                                controlType: 'label',
                                key: 'name'
                            }]
                    }, {
                        label: msg['au.COMPONENT.KtsConstructionMaterialComponent.label.manufacturers'],
                        items: [{
                                controlType: 'label',
                                key: 'manufacturers'
                            }]
                    }, {
                        label: msg['au.COMPONENT.KtsConstructionMaterialComponent.label.models'],
                        items: [{
                                controlType: 'label',
                                key: 'models'
                            }]
                    }, {
                        label: msg['au.COMPONENT.KtsConstructionMaterialComponent.label.quantity'],
                        controlType: 'number',
                        key: 'quantity',
                        params: { formClass: { width: '100' }, options: { min: '0' } }
                    }, {
                        label: msg['au.COMPONENT.KtsConstructionMaterialComponent.label.unit'],
                        items: [{
                                controlType: 'label',
                                key: 'unit'
                            }]
                    }]
            }];
        this.materialSpecial = $.extend(true, [], this.materialNormal);
        this.materialSpecial[0].items[1].items[1].label = msg['au.COMPONENT.KtsConstructionMaterialComponent.label.special']; // ●
        // メーカー：型番
        // keyはmaterialNormalと同じにする必要がある
        this.materialSpecial[0].items[4] = {
            controlType: 'text',
            key: 'manufacturers',
            params: { formClass: { width: '400' } },
            // 「4:メーカー」と「5:型番」を結合...(*)
            colspan: 2
        };
        this.materialSpecial[0].items[7] = {
            controlType: 'text',
            key: 'unit',
            params: { formClass: { width: '100' } }
        };
        // 「5:型番」を削除...(*)
        this.materialSpecial[0].items.splice(5, 1);
    }
    return TaskTemplate;
}());
export { TaskTemplate };
var GeneralTaskTemplate = /** @class */ (function () {
    function GeneralTaskTemplate(msg, readonly) {
        this.date = [];
        this.deliveryDestination = [];
        this.material = [];
        this.materialOrder = [];
        this.date = [{
                controlType: 'date',
                label: msg['au.COMPONENTS.label.task_plan_date'],
                key: 'plan_date',
                readonly: true
            }, {
                controlType: 'date',
                label: msg['au.COMPONENTS.label.task_act_date'],
                key: 'act_date',
                readonly: readonly
            }];
        this.deliveryDestination = [{
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_delivery_zipcode'],
                key: 'zipcode',
                readonly: readonly
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_delivery_address'],
                key: 'address',
                readonly: readonly,
                params: { formClass: { width: '50per' } }
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_delivery_tel'],
                key: 'tel',
                readonly: readonly
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_delivery_charge'],
                key: 'charge',
                readonly: readonly
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_delivery_arrival_note'],
                key: 'arrival_note',
                readonly: readonly,
                params: { formClass: { width: '50per' } }
            }];
        this.material = [{
                key: 'material',
                readonly: readonly,
                items: [{
                        label: msg['au.COMPONENT.KtsConstructionMaterialComponent.label.name'],
                        items: [{
                                controlType: 'text',
                                key: 'name',
                                params: { formClass: { width: '100' } }
                            }]
                    }, {
                        label: msg['au.COMPONENT.KtsConstructionMaterialComponent.label.elements'],
                        items: [{
                                controlType: 'text',
                                key: 'special_notes',
                                params: { formClass: { width: '400' } }
                            }]
                    }, {
                        label: msg['au.COMPONENT.KtsConstructionMaterialComponent.label.quantity'],
                        controlType: 'number',
                        key: 'quantity',
                        params: { formClass: { width: '100' }, options: { min: '0' } }
                    }, {
                        label: msg['au.COMPONENT.KtsConstructionMaterialComponent.label.unit'],
                        items: [{
                                controlType: 'text',
                                key: 'special_unit',
                                params: { formClass: { width: '100' } }
                            }]
                    }]
            }];
        var order = [{
                controlType: 'date',
                label: msg['au.COMPONENTS.label.task_desire_date'],
                key: 'desire_date',
                readonly: readonly
            }, {
                controlType: 'date',
                label: msg['au.COMPONENTS.label.task_order_date'],
                key: 'order_date',
                readonly: readonly
            }, {
                controlType: 'date',
                label: msg['au.COMPONENTS.label.task_delivery_date'],
                key: 'delivery_date',
                readonly: readonly
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_delivery_supplier'],
                key: 'delivery_supplier',
                readonly: readonly
            }];
        this.materialOrder = $.extend(true, [], this.material);
        this.materialOrder[0].items = this.materialOrder[0].items.concat(order);
    }
    return GeneralTaskTemplate;
}());
export { GeneralTaskTemplate };
//# sourceMappingURL=construction-material.service.js.map